module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('template-list', {
    attrs: {
      "me": _vm.me,
      "loading": _vm.$apollo.queries.templates.loading,
      "templates": _vm.templates
    },
    on: {
      "onSave": function($event) {
        return _vm.handleOnSave($event)
      },
      "onDelete": function($event) {
        return _vm.handleOnDelete($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76765ef3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/admin/EmailDashboardContainer.vue
// module id = 3343
// module chunks = 3